<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/H0lCwI/tc-custom/9781497652958.jpg?1734205650393" alt="This image is the cover for the book Tax in Blood, The Leo Haggerty Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Tax in Blood, The Leo Haggerty Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>A faked suicide sucks Leo Haggerty into the investigation of a terrorist bombing</b><br/><br/> Leo Haggerty walks the long wall of the Vietnam War Memorial, his girlfriend, Samantha, and his best friend, Arnie, at his sides. Arnie wanders away and meets a young boy whose mother asks if the veteran could lift her son up high enough to read the name of his uncle, his namesake. Some men might break down at the sight of the wall, but Arnie is stone-faced. Since he returned from ’Nam, nothing moves him at all. That night, a newsbreak: There’s been a bombing at the memorial. Nineteen are dead, including the child.<br/>  <br/> The FBI pursues the case doggedly, but they get nowhere, and it falls to Haggerty to prove that a man found dead in a motel room, suicide note by his side, did not, in fact, kill himself. As the case points him toward the bombers whose rampage has struck fear into the heart of Washington, DC, Haggerty will find out there’s a dark side to patriotism.<br/>  <br/><i>A Tax in Blood </i>is the 3rd book in the Leo Haggerty Mysteries, but you may enjoy reading the series in any order.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Benjamin M. Schutz
      </h2>
      
      <p class="authorDescription body article">Benjamin M. Schutz was an Edgar and Shamus Award&ndash;winning author, and was best known for his stories about PI Leo Haggerty. Based out of the Washington, DC, area, Schutz was also a practicing forensic and clinical psychologist, which influenced his writing a great deal. In his lifetime, he authored seven novels and a short story collection. Schutz passed away in 2008.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79390f9e